import request from '@/axios/bulletinBoard'

// 经营单元排名
export function getDepartmentRankingList(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/bloc_data/getDepartmentRankingList',
    method: 'post',
    data
  })
}

// 看板视野权限
export function getStaffDataWarehouseAuth(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/staff/staff_auth/getStaffDataWarehouseAuth',
    method: 'post',
    data
  })
}

// 02-获取员工详情
export function getManageStaffDetail(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/staff/staff/getStaffDetail',
    method: 'post',
    data
  })
}

// 02-获取员工详情
export function getWxStaffList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/staff/staff/getWxStaffList',
    method: 'post',
    data
  })
}

// 获取财年时间段
export function getFinancialYearTime(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/base/financial_year/getFinancialYearTime',
    method: 'post',
    data
  })
}

// 集团净利数据
export function getBlocNetMarginInfo(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/bloc_data/getBlocNetMarginInfo',
    method: 'post',
    data
  })
}

// 经营单元净利数据
export function getDepartmentNetMarginInfo(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/bloc_data/getDepartmentNetMarginInfo',
    method: 'post',
    data
  })
}

// 获取页面授权config
export function deliveryWxLogin(data) {
  return request({
    url: process.env.VUE_APP_BASE_WEIXIN + '/thirdpart/enterprise_wechat/wxLogin',
    method: 'post',
    data
  })
}

// 利润看板
export function getDepartmentNetMarginInfoStore(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/store_data/getDepartmentNetMarginInfo',
    method: 'post',
    data
  })
}

// 营收看板
export function getDepartmentIncomeInfo(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/store_data/getDepartmentIncomeInfo',
    method: 'post',
    data
  })
}

// 毛利率看板
export function getDepartmentGrossMarginInfo(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/store_data/getDepartmentGrossMarginInfo',
    method: 'post',
    data
  })
}

// 费用率看板
export function getDepartmentFeeInfo(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/store_data/getDepartmentFeeInfo',
    method: 'post',
    data
  })
}

export function getStoreIncomeDetailsList(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/store_data/getStoreIncomeDetailsList',
    method: 'post',
    data
  })
}

// 部门科目详情
export function getDepartmentSubjectDetail(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/store_data/getDepartmentSubjectDetail',
    method: 'post',
    data
  })
}

// 经营组数据看板
export function getLeastDepartmentDataInfo(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/store_data/getLeastDepartmentDataInfo',
    method: 'post',
    data
  })
}

// 经营影响因素
export function getImpactFactorInfo(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/impact_factor/getImpactFactorInfo',
    method: 'post',
    data
  })
}

// 毛利率影响因素-详情
export function getGrossMarginRateFactorDetails(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/impact_factor/getGrossMarginRateFactorDetails',
    method: 'post',
    data
  })
}

// 合伙人列表
export function getDepartmentPartnerList(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/store_data/getDepartmentPartnerList',
    method: 'post',
    data
  })
}
// 毛利分析-产品
export function getProductGrossMarginInfo(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/product_data/getProductGrossMarginInfo',
    method: 'post',
    data
  })
}
// 毛利分析-部门
export function getDepartmentConstituteAnalysis(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/product_data/getDepartmentConstituteAnalysis',
    method: 'post',
    data
  })
}
// 毛利分析-产品项
export function getProductConstituteAnalysis(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/product_data/getProductConstituteAnalysis',
    method: 'post',
    data
  })
}
// 输单分析
export function getLoseOrderInfo(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/product_data/getLoseOrderInfo',
    method: 'post',
    data
  })
}
// 输单订单
export function getConstituteLoseOrderList(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/product_data/getConstituteLoseOrderList',
    method: 'post',
    data
  })
}
// 输单类型
export function getLoseOrderTypeList(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/product_data/getLoseOrderTypeList',
    method: 'post',
    data
  })
}
// 产品图表
export function getProductLoseAreaAnalyse(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/product_data/getProductLoseAreaAnalyse',
    method: 'post',
    data
  })
}
// 异常毛利订单
export function getConstituteGrossMarginOrderList(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/product_data/getConstituteGrossMarginOrderList',
    method: 'post',
    data
  })
}
// 异常订单-产品组成分析
export function getCheckMarginRate(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/product_data/getCheckMarginRate',
    method: 'post',
    data
  })
}
// 赋能看板
export function getBlocHelpfulBoardInfo(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/bloc_data/getBlocHelpfulBoardInfo',
    method: 'post',
    data
  })
}

export function getInfluenceFactor(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/bloc_data/getInfluenceFactor',
    method: 'post',
    data
  })
}

// 业务-部门分析
export function getDepartmentAnalyse(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/market_data/getDepartmentBlocAnalyse',
    method: 'post',
    data
  })
}

export function getDepartmentManageAnomaly(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/bloc_data/getDepartmentManageAnomaly',
    method: 'post',
    data
  })
}
// 业务-渠道分析
export function getChannelAnalyse(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/market_data/getChannelBlocAnalyse',
    method: 'post',
    data
  })
}

// 经营-利润数据
export function getDepartmentNetMarginMarketInfo(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/market_data/getDepartmentNetMarginInfo',
    method: 'post',
    data
  })
}

// 经营-营收数据
export function getDepartmentIncomeMarketInfo(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/market_data/getDepartmentIncomeInfo',
    method: 'post',
    data
  })
}

// 经营-费用数据
export function getDepartmentFeeMarketInfo(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/market_data/getDepartmentFeeInfo',
    method: 'post',
    data
  })
}

// 经营-科目详情
export function getDepartmentSubjectMarketDetail(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/market_data/getDepartmentSubjectDetail',
    method: 'post',
    data
  })
}
// 业务-部门分析
export function getDepartmentMarketAnalyse(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/market_data/getDepartmentAnalyse',
    method: 'post',
    data
  })
}

// 业务-部门分析（部门人效维度）
export function getDepartmentManEfficiencyAnalyse(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/market_data/getDepartmentManEfficiencyAnalyse',
    method: 'post',
    data
  })
}

// 业务-部门分析（人为维度）
export function getDepartmentManAnalyse(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/market_data/getDepartmentManAnalyse',
    method: 'post',
    data
  })
}
// 业务-渠道分析
export function getChannelMarketAnalyse(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/market_data/getChannelAnalyse',
    method: 'post',
    data
  })
}

// 业务-赋能分析
export function getEnergizeAnalyse(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/market_data/getEnergizeAnalyse',
    method: 'post',
    data
  })
}

/**
 * 销售费用统计(总)
 * @param { * } data { section_time: string, department_id: string }
 * @returns Response Promise
 */
export function costStatistics(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/sale_data/costStatistics',
    method: 'post',
    data
  })
}

// 部门总满意率接口
export function getDepartmentTotalServerInfo(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_server/server_data/getDepartmentTotalServerInfo',
    method: 'post',
    data
  })
}

/**
 * 销售费用统计(总)
 * @param { * } data { section_time: string, department_id: string, board_auth_label: string }
 * @returns Response Promise
 */
export function getDepartmentCostList(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/sale_data/getDepartmentCostList',
    method: 'post',
    data
  })
}

/**
 * 销售费用统计(总)
 * @param { * } data { section_time: string, department_id: string, board_auth_label: string }
 * @returns Response Promise
 */
export function getAbnormalCostList(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/sale_data/getAbnormalCostList',
    method: 'post',
    data
  })
}

// 部门满意率列表接口
export function getDepartmentServerList(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_server/server_data/getDepartmentServerList',
    method: 'post',
    data
  })
}

// 异常情况接口
export function getDepartmentAbnormalList(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_server/server_data/getDepartmentAbnormalList',
    method: 'post',
    data
  })
}

// 获取财年时间段-数组
export function getFinancialYearTimeDate(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/base/financial_year/getFinancialYearTimeDate',
    method: 'post',
    data
  })
}
// 异常详情-经营
export function getAbnormalManageInfo(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/abnormal_data/getAbnormalManageInfo',
    method: 'post',
    data
  })
}
export function getTopButtonList(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/market_data/getTopButtonList',
    method: 'post',
    data
  })
}

// 工程能力-看板异常情况接口
export function getAbnormalYieldList(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/project_data/getAbnormalYieldList',
    method: 'post',
    data
  })
}
// 获取工单待办列表-经营
export function getManageWorkOrderList(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/work_order/getManageWorkOrderList',
    method: 'post',
    data
  })
}

/**
 * 1-B2C总计数据接口
 * @param data @type { department_id: string }
 * @returns @type AxiosPromise<any>
 */
export function getTotalCompliance(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/manpower_data/getTotalCompliance',
    method: 'post',
    data
  })
}

// 工程能力-部门达成率列表
export function getDepartmentYieldList(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/project_data/getDepartmentYieldList',
    method: 'post',
    data
  })
}
// 工单异常详情-经营
export function getManageWorkOrderInfo(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/work_order/getManageWorkOrderInfo',
    method: 'post',
    data
  })
}

// 4_成熟人员饱和率-总计接口
export function getTotalMatureSaturation(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/manpower_data/getTotalMatureSaturation',
    method: 'post',
    data
  })
}

// 工程能力-达标率
export function getProjectYeildRate(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/project_data/getProjectYeildRate',
    method: 'post',
    data
  })
}
// 响应处理-经营
export function saveWorkOrderResponse(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/work_order/saveWorkOrderResponse',
    method: 'post',
    data
  })
}

// 6_干部胜任达标率-总计接口
export function getTotalLeader(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/manpower_data/getTotalLeader',
    method: 'post',
    data
  })
}

// 04-监理能力达标率
export function getStaffYeildRate(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/project_data/getStaffYeildRate',
    method: 'post',
    data
  })
}
// 获取工单类型
export function getWorkOrderTypeList(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/work_order/getWorkOrderTypeList',
    method: 'post',
    data
  })
}

// 10-绩效达标率总计数据接口
export function getTotalPerformance(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/manpower_data/getTotalPerformance',
    method: 'post',
    data
  })
}

// 04-监理能力达标率
export function getSubjectList(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/project_data/getSubjectList',
    method: 'post',
    data
  })
}
// 获取异常数-我的任务
export function getManageWorkOrderAbnormalAmount(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/work_order/getManageWorkOrderAbnormalAmount',
    method: 'post',
    data
  })
}

// 2_B2C列表接口
export function getComplianceList(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/manpower_data/getComplianceList',
    method: 'post',
    data
  })
}

// 06-异常科目
export function getAbnormalSubjectList(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/project_data/getAbnormalSubjectList',
    method: 'post',
    data
  })
}

// 获取工单员工信息
export function getWorkOrderStaffInfo(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/work_order/getWorkOrderStaffInfo',
    method: 'post',
    data
  })
}

// 7_干部胜任达标率--列表接口
export function getLeaderAchieveList(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/manpower_data/getLeaderAchieveList',
    method: 'post',
    data
  })
}

// 5_成熟人员饱和率-达标率列表接口
export function getMatureAchieveList(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/manpower_data/getMatureAchieveList',
    method: 'post',
    data
  })
}

// 13_绩效达标率--收入达标人员接口
export function getStaffIncomeAchieveList(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/manpower_data/getStaffIncomeAchieveList',
    method: 'post',
    data
  })
}

// 11_员工收入达标人数接口
export function getStaffIncomeList(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/manpower_data/getStaffIncomeList',
    method: 'post',
    data
  })
}

// 12_绩效达标率-人效达标率接口
export function getStaffWorkpieceList(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/manpower_data/getStaffWorkpieceList',
    method: 'post',
    data
  })
}

// 9_干部替手列表接口副本
export function getLeaderReplaceList(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/manpower_data/getLeaderReplaceList',
    method: 'post',
    data
  })
}

// 3_B2C异常情况接口
export function getComplianceAbnormalList(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/manpower_data/getComplianceAbnormalList',
    method: 'post',
    data
  })
}

// 8_招聘人数列表接口
export function getInviteList(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/manpower_data/getInviteList',
    method: 'post',
    data
  })
}

// 21_门店成熟人员饱和率-达标率列表接口
export function getStoreMatureAchieveList(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/manpower_data/getStoreMatureAchieveList',
    method: 'post',
    data
  })
}

// 22_门店成熟人员饱和率-总计接口
export function getStoreTotalMatureSaturation(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/manpower_data/getStoreTotalMatureSaturation',
    method: 'post',
    data
  })
}

// 23_门店干部胜任达标率--列表接口
export function getStoreLeaderAchieveList(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/manpower_data/getStoreLeaderAchieveList',
    method: 'post',
    data
  })
}

// 24_店铺绩效达标率接口
export function getStoreStaffIncomeList(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/manpower_data/getStoreStaffIncomeList',
    method: 'post',
    data
  })
}
// 经营工单详情
export function getManageWorkOrderDetailsInfo(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/work_order/getManageWorkOrderDetailsInfo',
    method: 'post',
    data
  })
}
// 关闭工单
export function delWorkOrder(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/work_order/delWorkOrder',
    method: 'post',
    data
  })
}

// 获取关联工单
export function getRelevanceWorkOrderList(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/work_order/getRelevanceWorkOrderList',
    method: 'post',
    data
  })
}

// 添加关联工单
export function saveWorkOrderAssociated(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/work_order/saveWorkOrderAssociated',
    method: 'post',
    data
  })
}

// 获取工单分类
export function getWorkOrderCategoryList(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/work_order/getWorkOrderCategoryList',
    method: 'post',
    data
  })
}

// 部门列表
export function getDepartmentList(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/work_order/getDepartmentList',
    method: 'post',
    data
  })
}

// 创建工单-经营
export function saveWorkOrder(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/work_order/saveWorkOrder',
    method: 'post',
    data
  })
}

// 获取创建人和责任人
export function getStaffUserIds(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/work_order/getStaffUserIds',
    method: 'post',
    data
  })
}

// 工单处理
export function saveWorkOrderDispose(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/work_order/saveWorkOrderDispose',
    method: 'post',
    data
  })
}

// 经营工单-处理详情
export function getResponseWorkOrderInfo(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/work_order/getResponseWorkOrderInfo',
    method: 'post',
    data
  })
}

// 工单处理-响应编辑
export function saveResponseWorkOrder(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/work_order/saveResponseWorkOrder',
    method: 'post',
    data
  })
}
// 获取工单部门列表
export function getWorkOrderDepartmentList(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/work_order/getWorkOrderDepartmentList',
    method: 'post',
    data
  })
}

// 获取工单部门列表
export function getIndividualWorkOrderInfo(data, config) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/work_order/getIndividualWorkOrderInfo',
    method: 'post',
    data,
    ...config
  })
}

// 获取员工和部门列表
export function getStaffDepartmentList(data, config) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/work_order/getStaffDepartmentList',
    method: 'post',
    data,
    ...config
  })
}

// 净利趋势图
export function getNetMarginTendencyChart(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/tendency_chart/getNetMarginTendencyChart',
    method: 'post',
    data
  })
}

// 收入趋势图
export function getIncomeTendencyChart(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/tendency_chart/getIncomeTendencyChart',
    method: 'post',
    data
  })
}

// 01-筛选标签列表
export function getFilterTabDepartmentList(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/ranking_list/getFilterTabDepartmentList',
    method: 'post',
    data
  })
}

// 02-事业部排名
export function getBusinessDepartmentRanking(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/ranking_list/getBusinessDepartmentRanking',
    method: 'post',
    data
  })
}

// 03-门店排名
export function getStoreDepartmentRanking(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/ranking_list/getStoreDepartmentRanking',
    method: 'post',
    data
  })
}

// 04-小组排名
export function getGroupDepartmentRanking(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/ranking_list/getGroupDepartmentRanking',
    method: 'post',
    data
  })
}

// 05-切换标签列表
export function getCutTabDepartmentList(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/ranking_list/getCutTabDepartmentList',
    method: 'post',
    data
  })
}
// 01 - 赋能看板产品能力
export function getProductInfo(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/bloc_data/getProductInfo',
    method: 'post',
    data
  })
}
// 02 - 赋能看板销售线索
export function getSaleClue(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/bloc_data/getSaleClue',
    method: 'post',
    data
  })
}
// 03 - 赋能看板销售费用
export function getSaleCost(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/bloc_data/getSaleCost',
    method: 'post',
    data
  })
}
// 04 - 赋能看板工程能力
export function getProjectInfo(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/bloc_data/getProjectInfo',
    method: 'post',
    data
  })
}
// 05 - 赋能看板服务满意度
export function getServiceInfo(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/bloc_data/getServiceInfo',
    method: 'post',
    data
  })
}
// 06 - 赋能看板组织能力
export function getManpowerInfo(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/bloc_data/getManpowerInfo',
    method: 'post',
    data
  })
}

// 回款看板
export function getDepartmentBackInfo(data, config) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/back_data/getDepartmentBackInfo',
    method: 'post',
    data,
    ...config
  })
}

// 获取看板门店标签
export function getStoreLabel(data, config) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/base/label/getStoreLabel',
    method: 'post',
    data,
    ...config
  })
}

// 驳回工单 - V2.1
export function rejectWorkOrder(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/work_order/rejectWorkOrder',
    method: 'post',
    data
  })
}

// 获取工单部门状态列表-V2.1
export function getWorkOrderDepartmentStatusList(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/work_order/getWorkOrderDepartmentStatusList',
    method: 'post',
    data
  })
}

// 工单处理详情-V2.1
export function getDisposeWorkOrderInfo(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/work_order/getDisposeWorkOrderInfo',
    method: 'post',
    data
  })
}

// 工单筛选-V2.3
export function getWorkOrderScreenList(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/work_order/getWorkOrderScreenList',
    method: 'post',
    data
  })
}
// 获取责任人
export function getDutyStaffList(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/work_order/getDutyStaffList',
    method: 'post',
    data
  })
}
// 添加评论
export function saveComment(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/work_order/saveComment',
    method: 'post',
    data
  })
}
// 评论列表
export function getCommentList(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/work_order/getCommentList',
    method: 'post',
    data
  })
}
// 删除评论
export function delComment(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/work_order/delComment',
    method: 'post',
    data
  })
}
